export enum LabelTemplateKinds {
    Label,
    Pricing,
    Card
}